import { render, staticRenderFns } from "./HomeSectionCollection.vue?vue&type=template&id=9323869a&"
import script from "./HomeSectionCollection.vue?vue&type=script&lang=js&"
export * from "./HomeSectionCollection.vue?vue&type=script&lang=js&"
import style0 from "./HomeSectionCollection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports